export const FileIsTooLargeModal: string = 'FileIsTooLargeModal';
